import { QueryStatus } from '@tanstack/react-query';
import useLoanConstraintsQuery from './useLoanConstraintsQuery';

export interface UseTerm {
  status: QueryStatus;
  term?: number;
}

const useTerm = (): UseTerm => {
  const loanConstraintsQuery = useLoanConstraintsQuery();

  return {
    status: loanConstraintsQuery.status,
    term: loanConstraintsQuery.loanConstraints?.termInterval?.defaultValue,
  };
};

export default useTerm;
